export interface Queue {
	id?: number | null;
	linkId: number;
	executeAt?: Date | null;
	trigger: QueueTrigger;
	creationDate?: Date | null;
	status?: QueueStatus;
}

export enum QueueTrigger {
	Undefined = 0,
	User = 1,
	Scheduler = 2,
}

export enum QueueStatus {
	Unknown = 0,
	Waiting = 1,
	AboutToCreateBatch = 2,
	CreatedBatch = 3,
	Completed = 4,
	InProgress = 6,
	Failed = 7,
}
